module.exports = "<p>\n  SISTEMA DE BIENESTAR ESTUDIANTIL Y POLITÉCNICO\n  <b>Autor:</b> Herná Darío Centeno Aulla\n</p>"